
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'

import Packages from './pages/Packages'

import Contact from './pages/Contact'


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import FloatingActionMenu from './components/FloatingActionMenu';
import { ThankYou } from './pages/ThankYou';




import { SixDaysTanzaniaAffordableSafaris } from './pages/ToursPages.jsx/SixDaysTanzaniaAffordableSafaris';
import { FiveNgorongoroHiglandTrekking } from './pages/ToursPages.jsx/FiveNgorongoroHiglandTrekking';
import { TwoDaysTanzaniasafari } from './pages/ToursPages.jsx/TwoDaysTanzaniasafari';
import { ThreeDaysTanzaniaSafaris } from './pages/ToursPages.jsx/ThreeDaysTanzaniaSafaris';
import { FourDaysTanzaniasafaris } from './pages/ToursPages.jsx/FourDaysTanzaniasafaris';
import { EightDaysTanzaniaAffordableSafari } from './pages/ToursPages.jsx/EightDaysTanzaniaAffordableSafari';
import { NineDaysSafari } from './pages/ToursPages.jsx/NineDaysSafari';
import { ClimbingTours } from './pages/ClimbingTours';
import { SevenDaysTanzaniaSafari } from './pages/ToursPages.jsx/SevenDaysTanzaniaSafari'
import { ElevenDaysChimpanzeeTrekkingMahaleGombe } from './pages/ToursPages.jsx/ElevenDaysChimpanzeeTrekkingMahaleGombe'
import { FourDaysCampingSafaris } from './pages/ToursPages.jsx/FourDaysCampingSafaris'
import { OneDayNyerereNationalParkTour } from './pages/ToursPages.jsx/OneDayNyerereNationalParkTour'
import { Gallery } from './pages/Gallery'
import { FourDaysNgorongorohiglandtrekking } from './pages/ToursPages.jsx/FourDaysNgorongorohiglandtrekking'
import { FourDaysZanzibarHolidays } from './pages/ToursPages.jsx/FourDaysZanzibarHolidays'
import { SixDAYSDAYTRIPTOKILIMANJAROANDSAFARI } from './pages/ToursPages.jsx/SixDAYSDAYTRIPTOKILIMANJAROANDSAFARI'
import { SevenDaysZanzibarHoneymoonersHoliday } from './pages/ToursPages.jsx/SevenDaysZanzibarHoneymoonersHoliday'
import { EightDayskilimanjaroclimb } from './pages/ToursPages.jsx/EightDayskilimanjaroclimb'
import { TwoDaysNyerereNationalPark } from './pages/ToursPages.jsx/TwoDaysNyerereNationalPark'
import { TanzaniaAndZanzibarPackages } from './pages/TanzaniaAndZanzibarPackages'
import { FourteenDaysBushToBeachHolidays } from './pages/ToursPages.jsx/FourteenDaysBushToBeachHolidays'
import { FourteenDaysBestOfKenyaAndTanzania } from './pages/ToursPages.jsx/FourteenDaysBestOfKenyaAndTanzania'
export default function App() {

  return (
    <div>
      <Header />
      <Routes>
       
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/safaris_packages' element={<Packages />} />
        <Route path='/climbing_tours' element={< ClimbingTours />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/ThankYou' element={<ThankYou />} />
       
        
        <Route path='/SixDaysTanzaniaAffordableSafaris' element={< SixDaysTanzaniaAffordableSafaris />} />
        <Route path='/FiveNgorongoroHiglandTrekking' element={< FiveNgorongoroHiglandTrekking />} />
        <Route path='/TwoDaysTanzaniasafari' element={< TwoDaysTanzaniasafari />} />
        <Route path='/ThreeDaysTanzaniaSafaris' element={< ThreeDaysTanzaniaSafaris />} />
        <Route path='/FourDaysTanzaniasafaris' element={< FourDaysTanzaniasafaris />} />
        <Route path='/EightDaysTanzaniaAffordableSafari' element={< EightDaysTanzaniaAffordableSafari />} />
        <Route path='/NineDaysSafari' element={< NineDaysSafari />} />
        <Route path='/SevenDaysTanzaniaSafari' element={< SevenDaysTanzaniaSafari />} />
        <Route path='/ElevenDaysChimpanzeeTrekkingMahaleGombe' element={< ElevenDaysChimpanzeeTrekkingMahaleGombe />} />
        <Route path='/FourDaysCampingSafaris' element={< FourDaysCampingSafaris />} />
        <Route path='/OneDayNyerereNationalParkTour' element={< OneDayNyerereNationalParkTour />} />
        <Route path='/Gallery' element={< Gallery />} />
        <Route path='/FourDaysNgorongorohiglandtrekking' element={< FourDaysNgorongorohiglandtrekking />} />
        <Route path='/FourDaysZanzibarHolidays' element={< FourDaysZanzibarHolidays />} />
        <Route path='/SixDAYSDAYTRIPTOKILIMANJAROANDSAFARI' element={< SixDAYSDAYTRIPTOKILIMANJAROANDSAFARI />} />
        <Route path='/SevenDaysZanzibarHoneymoonersHoliday' element={< SevenDaysZanzibarHoneymoonersHoliday />} />
        <Route path='/EightDayskilimanjaroclimb' element={< EightDayskilimanjaroclimb />} />
          <Route path='/TwoDaysNyerereNationalPark' element={< TwoDaysNyerereNationalPark />} />
          <Route path='/TanzaniaAndZanzibarPackages' element={< TanzaniaAndZanzibarPackages />} />
          <Route path='/FourteenDaysBushToBeachHolidays' element={< FourteenDaysBushToBeachHolidays />} />
           <Route path='/FourteenDaysBestOfKenyaAndTanzania' element={< FourteenDaysBestOfKenyaAndTanzania />} />

      </Routes>
      <FloatingActionMenu />
      <Footer />
    </div>
  )
}
